import React from 'react'
import { Block } from '@comp/crRender'
import { useTranslation } from 'react-i18next'
import {
    BasicInformation,
    Accreditations,
    AdvancedTechnologies,
    Specialties,
    Testimonials,
    RefundPolicy,
    Gallery,
    Certifications,
    VideoSection,
    Keywords,
    ContactInformation,
    TopRatedDoctors
} from './sections'

const Details = ({ requestDetails }) => {
    const { t } = useTranslation()


    return (
        <Block isRender={true} className="hospital-profile-container">
            {/* Header */}
            <div className="hospital-profile-header">
                <h1 className="hospital-profile-title">{t("hospital-portfolio")}</h1>
            </div>

            {/* Main Content Grid */}
            <div className="hospital-profile-grid">
                {/* Left Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    <BasicInformation requestDetails={requestDetails} />

                    <Accreditations accredations={requestDetails?.accredations || []} />

                    <AdvancedTechnologies technologies={[]} />

                    <Specialties serviceCategories={requestDetails?.serviceCategories || []} />

                    {/* Gallery and Video in same row */}
                    <div className="media-row">
                        <Gallery srcLink={window.WEB_LINK} galleryImages={requestDetails?.certifications || []} />
                        <VideoSection videoUrl={requestDetails?.videoUrl || "  "} />
                    </div>

                    <Certifications certifications={requestDetails?.certifications} />

                    <Keywords keywords={requestDetails?.keywords || []} />

                    <Testimonials testimonials={requestDetails?.testimonials || []} />

                    <RefundPolicy refundPolicy={requestDetails?.refundPolicy || t('refund-policy-text')} />

                </div>

                {/* Right Column */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    <ContactInformation requestDetails={requestDetails} />
                    {
                        <TopRatedDoctors topDoctors={requestDetails?.topDoctors || []} />
                    }
                </div>
            </div>
        </Block>
    )
}

export default Details
